module.exports = __webpack_public_path__ + "Lato-Medium.cecc32d267ee07ce3413.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Medium.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Medium.eot
// module chunks = styles